import * as React from "react";
import { IShortCodeLink } from "@nkr/models/index";

interface IProps {
    shortCodeLink: IShortCodeLink,
    onToggleEnable: (shortCodeLink:IShortCodeLink)=>void
}

class ShortCodeRow extends React.Component<IProps, {}> {
    toggleEnable = () => {
        this.props.onToggleEnable(this.props.shortCodeLink);
    }

    render = () => {
        return (
            <div>
                <div className="row">
                    <div className="col-xs-6"><h4 style={{ marginTop: 1 }}><span className="label label-default">{this.props.shortCodeLink.id}</span></h4></div>
                    <div className="col-xs-6 text-right">
                        {this.props.shortCodeLink.isActive ?
                            <button type="button" className="btn btn-success" value={this.props.shortCodeLink.id} onClick={this.toggleEnable}>Active</button>
                            :
                            <button type="button" className="btn btn-default" value={this.props.shortCodeLink.id} onClick={this.toggleEnable}>Disabled</button>
                        }
                    </div>
                </div>
                <div className="row">
                    <div className="col-xs-12" style={{ marginBottom: 5 }}><strong>{this.props.shortCodeLink.link}</strong></div>
                    <div className="col-xs-12" style={{ marginBottom: 5 }}>Created: {this.props.shortCodeLink.createdDateTime}</div>
                    <div className="col-xs-12" >Clicks: {this.props.shortCodeLink.clickCount}</div>
                </div>
                <hr></hr>
            </div>
        );
    }
}

export default ShortCodeRow;